export default __webpack_public_path__ + "static/media/detail_mobile_1_4.d5c943ce.png";